module.exports = {"TXTWCL_Watch_Trailer":{"id":"TXTWCL_Watch_Trailer","defaultMessage":"予告編を見る","flags":["TRACK"],"track":"Watch Trailer"}}